import { render, staticRenderFns } from "./Energy.vue?vue&type=template&id=16bdf81a&"
import script from "./Energy.vue?vue&type=script&lang=ts&"
export * from "./Energy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports